// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c9da10ca9b473953","5285":"757a2ce048c586eb"}[chunkId] + ".css";
};